import Aws from '@components/Aws';
import Button from '@components/Button';
import ModalText from '@components/ModalText';
import Orb from '@components/Orb';
import ResultNextComponentMessage from '@components/ResultsNextComponentMessge';
import { ResultsBannerType } from '@data/types';
import useStore from '@store/store';
import React, { useEffect, useState } from 'react';
import { generatePDF } from 'utilities/generatePdf';

interface Props extends ResultsBannerType {
  as?: keyof JSX.IntrinsicElements;
}

const ResultsBanner: React.FC<Props> = ({
  as: Component = 'div',
  htmlContent,
  button,
}) => {
  const [displayModal, setDisplayModal] = useState<boolean>(false);
  const { setGeneratingPDF } = useStore();

  useEffect(() => {
    if (displayModal) {
      setGeneratingPDF(true);
      setTimeout(async () => {
        await generatePDF();
        setDisplayModal(false);
        setGeneratingPDF(false);
      }, 1000);
    }
  }, [displayModal]);

  return (
    <>
      <Component
        className="results-banner w-full bg-gradient-to-b from-red-dark to-[50%] to-[#242149] flex"
        data-pdf-page
      >
        <div className="flex flex-grow flex-col">
          <div className="px-4 pb-4 pt-0 xl:px-0 md:py-8 w-full max-w-outerGrid h-full flex gap-4 flex-col mx-auto">
            <div className="flex flex-col lg:flex-row mt-auto items-center">
              <figure className="block aspect-square max-w-[32rem] mx-auto w-full lg:w-3/5 relative">
                <Orb pillarIndex={6} questionIndex={0} />
              </figure>
              <div className="w-full lg:w-2/5">
                <div
                  className="prose text-white prose-headings:text-white prose-h1:text-2xl lg:prose-h1:text-3xl prose-h1:font-lightNormal"
                  dangerouslySetInnerHTML={
                    htmlContent ? { __html: htmlContent } : undefined
                  }
                ></div>
                <Button
                  {...button}
                  className="!mt-10 pdf-hide"
                  type="button"
                  onClick={() => setDisplayModal(!displayModal)}
                />
              </div>
            </div>
            <div className="hidden lg:flex w-full mt-auto pt-4 -translate-y-[4vh]">
              <ResultNextComponentMessage message="See your results" />
              <div className="ml-auto">
                <Aws />
              </div>
            </div>
          </div>
        </div>
      </Component>
      {displayModal && (
        <ModalText
          setDisplayModal={setDisplayModal}
          displayModal={displayModal}
          message={'Generating PDF...'}
        />
      )}
    </>
  );
};

export default ResultsBanner;
